import React from 'react';
import { useAppSelector } from '../../../state/hooks';
import getTranslationsByLangOrEng from '../../../utils/getTranslationsByLangOrLang';
import { ConsumerJourneyMapExpertsStyles } from './styles';
import experts1 from '../../../assets/images/consumerJourneyMap/experts-1.png';
import experts2 from '../../../assets/images/consumerJourneyMap/experts-2.png';
import experts3 from '../../../assets/images/consumerJourneyMap/experts-3.png';

export const ConsumerJourneyMapExperts = () => {
  const { interfaceLanguage } = useAppSelector((state) => state.languages);
  return (
    <ConsumerJourneyMapExpertsStyles>
      <div className="container">
        <h5> </h5>
        <div className="content">
          <h2>
            {getTranslationsByLangOrEng(interfaceLanguage, 'consumer_journey_map_28')}
          </h2>
        </div>
      </div>
      <div className="full-container">
        <div className="cards">
          <div className="cards-item">
            <img src={experts1} alt="experts" />
            <p>{getTranslationsByLangOrEng(interfaceLanguage, 'consumer_journey_map_29')}</p>
          </div>
          <div className="cards-item">
            <img src={experts2} alt="experts" />
            <p>{getTranslationsByLangOrEng(interfaceLanguage, 'consumer_journey_map_30')}</p>
          </div>
          <div className="cards-item">
            <img src={experts3} alt="experts" />
            <p>{getTranslationsByLangOrEng(interfaceLanguage, 'consumer_journey_map_31')}</p>
          </div>
        </div>
      </div>
    </ConsumerJourneyMapExpertsStyles>
  );
};
